import { getBirdviewChartCardSkeletonContent } from './BirdviewChartCardSkeleton.utils'

import * as styles from './BirdviewChartCardSkeleton.module.css'

function BirdviewChartCardSkeleton({ type }) {
  return (
    <div className={styles.skeleton}>
      {getBirdviewChartCardSkeletonContent(type)}
    </div>
  )
}

export default BirdviewChartCardSkeleton
